var React = require('react');

function IconLinkBlank (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M741.6 191.6H512.2v-128h448v448h-128V282.1L429.4 684.8l-90.5-90.5 402.7-402.7zm-549.4 640h511.9v-192h128v320H64.2v-768h320v128h-192v512z"}));
}

IconLinkBlank.displayName = "IconLinkBlank";

IconLinkBlank.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconLinkBlank;

IconLinkBlank.default = IconLinkBlank;
